import type { JSX } from 'react';
import { Button, type ButtonProps } from './button.js';

export interface SaveButtonProps extends Omit<ButtonProps, 'disabled'> {
  /** `false` = brouillon identique à la dernière version enregistrée. */
  isDirty: boolean;
  /** Autre motif de désactivation (champ requis vide…). */
  disabled?: boolean;
}

/**
 * Bouton d'enregistrement inactif tant que rien n'a changé depuis la dernière
 * sauvegarde, avec la mention « Aucune modification » : après un clic, le
 * retour à l'état inactif confirme que l'enregistrement a abouti.
 */
export function SaveButton({
  isDirty,
  disabled = false,
  children = 'Enregistrer',
  type = 'submit',
  ...props
}: SaveButtonProps): JSX.Element {
  return (
    <span className="inline-flex flex-wrap items-center justify-end gap-3">
      {isDirty ? null : <span className="text-sm text-muted-foreground">Aucune modification</span>}
      <Button type={type} disabled={disabled || !isDirty} {...props}>
        {children}
      </Button>
    </span>
  );
}
